import { meshComponent } from './Mesh'
import { props, createGeometry } from '../geometries/RingGeometry'

export default meshComponent('Ring', props, createGeometry)
